export const API_ENDPOINTS = {
  RRUrl: '/product-references/api/1/product-references',
};

export const OCC_ENDPOINTS = {
  firstVisitLog: '/first-visit-log',
};
